import React, {Component} from 'react';
import {connect} from 'react-redux'
import {InputGroup,Form,FormControl,FormGroup} from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'
import Select from 'react-select';
import AssetStore from 'stores/AssetStore'
const NotificationSystem = require('react-notification-system')

class AssetToolBar extends Component {

  constructor(...args){
    super(...args)

    this.state = {
        category:[],
        sub_category:[],
        cat_id:'',
        sub_cat_id:'',
        query:'',
        data:[]
    }
  }

  componentDidMount() {
    this.loadReportAssetCategory()
  }

  componentWillReceiveProps(newProps) {
     
  }

  loadData(query,cat_id,sub_cat_id) {
      AssetStore.loadReportAssetBySearch(query,cat_id,sub_cat_id,(result)=>{
        this.setState({data:result.data})
        if (this.props.onSerach!==undefined)
            this.props.onSerach(result.data)
      })
  }

  loadReportAssetCategory() {
    this.setState({loading:true})
    AssetStore.loadReportAssetCategory('',(result)=>{
      let category = []
      category = result.data.map((item,index)=>{
        return {label:item.name,value:item.cat_id}
      })
      this.setState({loading:false,category:category})
    })
  }

  loadReportAssetSubCategory(cat_id) {
    this.setState({loading:true})
    AssetStore.loadReportAssetCategory(cat_id,(result)=>{
      let sub_category = []
      sub_category = result.data.map((item,index)=>{
        return {label:item.name,value:item.cat_id}
      })
      this.setState({loading:false,sub_category:sub_category})
      this.loadData(this.state.query,cat_id,'')
    })
  }

  onCategoryChange(e) {
    let {cat_id,sub_cat_id,sub_category} = this.state
    if (e!==null) {
        cat_id = e.value
        this.loadReportAssetSubCategory(cat_id)
    } else {
        cat_id = ''
        sub_category = []
        this.loadData(this.state.query,'','')
    }
    sub_cat_id = ''
    this.setState({cat_id:cat_id,sub_cat_id:sub_cat_id,sub_category:sub_category})
  }

  onSubCategoryChange(e) {
    let {sub_cat_id} = this.state
    if (e!==null)
        sub_cat_id = e.value
    else
        sub_cat_id = '' 
    this.setState({sub_cat_id:sub_cat_id})
    this.loadData(this.state.query,this.state.cat_id,sub_cat_id)
  }

  onTextChange(e) {
    let {query} = this.state
    query = e.target.value
    this.setState({query:query})
  }

  onSearchClick() {
    this.loadData(this.state.query,this.state.cat_id,this.state.sub_cat_id)
  }

  onSearchKeyPress(e) {
    if (e.charCode===13) {
        e.preventDefault()
        this.onSearchClick()
    }
  }

  render() {
      return(
          <div style={{marginBottom:'10px'}}>
            <Form inline>
              <FormGroup>
                <Select
                  clearable={true}
                  placeholder='--- เลือก ---'
                  name="form-field-name"
                  value={this.state.cat_id}
                  options={this.state.category}
                  style={{width:'200px'}}
                  onChange={this.onCategoryChange.bind(this)}
                />
              </FormGroup>
              {' '}
              <FormGroup>
                <Select
                  clearable={true}
                  placeholder='--- เลือก ---'
                  name="form-field-name"
                  value={this.state.sub_cat_id}
                  options={this.state.sub_category}
                  style={{width:'200px'}}
                  onChange={this.onSubCategoryChange.bind(this)}
                />
              </FormGroup>
              {' '}
              <FormGroup>
                <InputGroup>
                  <InputGroup>
                    <FormControl value={this.state.query} placeholder="ชื่อรายการ..." onChange={this.onTextChange.bind(this)} onKeyPress={this.onSearchKeyPress.bind(this)} />
                    <InputGroup.Addon className="btn" onClick={this.onSearchClick.bind(this)}>
                      <FontAwesome name='search' />
                    </InputGroup.Addon>
                  </InputGroup>
                </InputGroup>
              </FormGroup>
            </Form>
            <NotificationSystem ref="notificationSystem" />  
          </div>
      )
  }
}  

AssetToolBar.defaultProps = {
    data:[]
}

export default AssetToolBar = connect(
  (state) => ({messages: state.message.view.tyre.AssetToolBar}),null,null,{withRef:true}
)(AssetToolBar);



// WEBPACK FOOTER //
// ./src/view/tyre/report-asset-vehicle-page/AssetToolBar.js